import { AnyAction } from "redux";
import { COMING_FROM_CASE, REFERRAL_FOR, REFERRAL_INCLUSION_TEAM, REFERRAl_REASON, REFERRAL_OTHER_DETAILS, CLEAR_REFERRAL_INFO, COMING_FROM_REFERRAL, REFERRAL_ADDITIONAL_DETAILS, REFERRAL_ACCOUNT_BALANCE, REASON_RESPONSE, IS_CASE_JOURNEY, IS_REPAIR_JOURNEY, SELECTED_SLOT, IS_TRIAGE_REPAIR, DMC_DATA, DMC_ANS_DATA, REMOVE_DMC_DATA, STORE_SORDAMP, IS_CONTINUE_BUTTON_DISABLED, CALENDER_INDEX, CALENDER_VALUE_OF_TRACK, DMC_CALENDER_VALUE_OF_TRACK, DMC_CALENDER_INDEX } from "../actionTypes";

const initialState = {
    financialReferralData: {
        referralFor: "",
        FinancialInclusionTeam: "",
        ReferralReason: [],
        ReferralOtherDetails: "",
    },
    isComingFromReferral: false,
    referralDetails: "",
    referralAccountBalance: "",
    referralReasonResponse: [],
    isComingFromCase: false,
    isCaseJourneyMessage: false,
    isRepairJourneyMessage: false,
    isAlertMessage: false,
    DMCData: {},
    DMCAnsData: {},
    sordamp: "",
    isContinueButtonDisabled: false,
    calenderIndex: [],
    calenderTrackNumber: "",
    dmcCalenderIndex:[],
    dmcCalenderTrackNumber:""
}


export const FinancialReferralReducer = (state: any = initialState, action: AnyAction) => {
    switch (action.type) {
        case REFERRAL_FOR:
            return {
                ...state,
                financialReferralData: {
                    ...state.financialReferralData,
                    referralFor: action.payload
                }
            };
        case REFERRAL_INCLUSION_TEAM:
            return {
                ...state,
                financialReferralData: {
                    ...state.financialReferralData,
                    FinancialInclusionTeam: action.payload
                }
            }
        case REFERRAl_REASON:
            return {
                ...state,
                financialReferralData: {
                    ...state.financialReferralData,
                    ReferralReason: action.payload
                }
            }
        case REFERRAL_OTHER_DETAILS:
            return {
                ...state,
                financialReferralData: {
                    ...state.financialReferralData,
                    ReferralOtherDetails: action.payload
                }
            }
        case CLEAR_REFERRAL_INFO:
            return {
                ...state,
                financialReferralData: {
                    referralFor: "",
                    FinancialInclusionTeam: "",
                    ReferralReason: [],
                    ReferralOtherDetails: "",


                },
                isComingFromReferral: false,
                referralDetails: "",
                referralReasonResponse: [],
                isComingFromCase: false
            }

        case COMING_FROM_REFERRAL:
            return {
                ...state,
                isComingFromReferral: action.payload
            }
        case REFERRAL_ADDITIONAL_DETAILS:
            return {
                ...state,
                referralDetails: action.payload
            }
        case REFERRAL_ACCOUNT_BALANCE:
            return {
                ...state,
                referralAccountBalance: action.payload
            }
        case REASON_RESPONSE:
            return {
                ...state,
                referralReasonResponse: action.payload
            }
        case COMING_FROM_CASE:
            return {
                ...state,
                isComingFromCase: action.payload
            }
        case IS_CASE_JOURNEY:
            return {
                ...state,
                isCaseJourneyMessage: action.payload
            }
        case IS_REPAIR_JOURNEY:
            return {
                ...state,
                isRepairJourneyMessage: action.payload
            }
        case SELECTED_SLOT:
            return {
                ...state,
                selectedDateSlot: action.payload
            }
        case IS_TRIAGE_REPAIR:
            return {
                ...state,
                isTriageRepair: action.payload
            }

        case DMC_DATA:
            return {
                ...state,
                DMCData: action.payload
            }
        case DMC_ANS_DATA:
            return {
                ...state,
                DMCAnsData: action.payload
            }
        case REMOVE_DMC_DATA:
            return {
                ...state,
                DMCAnsData: {},
                DMCData: {}
            }
        case STORE_SORDAMP:
            return {
                ...state,
                sordamp: action.payload
            }
        case IS_CONTINUE_BUTTON_DISABLED:
            return {
                ...state,
                isContinueButtonDisabled: action.payload
            }
        case CALENDER_INDEX:
            return {
                ...state,
                calenderIndex: action.payload
            }
        case CALENDER_VALUE_OF_TRACK:
            return {
                ...state,
                calenderTrackNumber: action.payload
            }
            case DMC_CALENDER_INDEX:
            return {
                ...state,
                dmcCalenderIndex: action.payload
            }
        case DMC_CALENDER_VALUE_OF_TRACK:
            return {
                ...state,
                dmcCalenderTrackNumber: action.payload
            }
        default:
            return state;
    }
};